export default __webpack_public_path__ + "static/media/error-picture.43a0ec4e.png";